import { Component, Input, OnInit, OnDestroy, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { MediaObserver } from '@angular/flex-layout';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { MEDIA_ALISES } from '~shared/constants/media.constant';
import { ContentCard } from '../../models';
import { Components } from '~app/modules/storyblok/constants';

@Component({
  selector: 'app-content-card-list',
  templateUrl: './content-card-list.component.html',
  styleUrls: ['./content-card-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ContentCardListComponent implements OnInit, OnDestroy {
  @Input() title: string;
  @Input() cards: Array<ContentCard>;

  readonly NOT_EXPANDED_LIMIT = 4;
  readonly COMPONENTS = Components;
  isMobile = true;
  isExpanded = false;

  private unsubscribe$ = new Subject<void>();

  get limit(): number {
    return this.isExpanded || !this.isMobile ? this.cards.length : this.NOT_EXPANDED_LIMIT;
  }

  constructor(private mediaObserver: MediaObserver, private cd: ChangeDetectorRef) {}

  ngOnInit(): void {
    this.initMediaObserver();
  }

  private initMediaObserver(): void {
    this.mediaObserver
      .asObservable()
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(() => {
        this.isMobile = this.mediaObserver.isActive(MEDIA_ALISES.mobile);
        this.cd.markForCheck();
      });
  }

  toggleExpanded(): void {
    this.isExpanded = !this.isExpanded;
    this.cd.markForCheck();
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
